// extracted by mini-css-extract-plugin
export default {"cls1":"FilterHeader-Header_cls1__YkaKd","cls2":"FilterHeader-Header_cls2__mot-S FilterHeader-Header_cls1__YkaKd"};